module.exports = __webpack_public_path__ + "static/media/bl_4bhk_pent.70284089.jpg";